import { Dialog } from '@progress/kendo-react-dialogs';
import { Form, Field, FormElement } from '@progress/kendo-react-form';
import { Input } from '@progress/kendo-react-inputs';
import { useEffect } from 'react';

const RenameItem = ({ onSubmit, onCancel, title, currentName }: any) => {
  useEffect(() => {
    // Focus the rename input the first time the dialog mounts so the
    // user can start typing immediately. requestAnimationFrame waits one
    // frame so the dialog content is actually in the DOM before we query.
    // Kendo's `Input` component renders the `k-input` classes directly on
    // the `<input>` element (no `.k-input-inner` wrapper), so we target
    // it via `.k-dialog input.k-input`. `.select()` selects all the text
    // so a quick "type to replace" works, while leaving Home/End/arrows
    // usable for partial edits.
    const id = window.requestAnimationFrame(() => {
      const input = document.querySelector<HTMLInputElement>('.k-dialog input.k-input');
      input?.focus();
      input?.select();
    });
    return () => window.cancelAnimationFrame(id);
  }, []);

  return (
    <Dialog title={title} onClose={onCancel}>
      <Form
        onSubmit={onSubmit}
        initialValues={{name:currentName}}
        render={(formRenderProps) => (
          <FormElement
            style={{
              maxWidth: 650,
              width: 300,
            }}
          >
            <fieldset className={'k-form-fieldset'}>
              <div className="mb-3">
                <Field name={'name'} component={Input} label={'New name'} />
              </div>
            </fieldset>
            <div className="k-form-buttons">
              <button
                type={'submit'}
                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                disabled={!formRenderProps.allowSubmit}
              >
                Submit
              </button>
            </div>
          </FormElement>
        )}
      />
    </Dialog>
  );
};

export default RenameItem;
